import React , {Component} from 'react'
import { connect } from 'react-redux'
import Navbar from 'components/navbar/Navbar'
import Fade from 'react-reveal/Fade'
import { HashLink } from 'react-router-hash-link'
import scrollIntoView from 'scroll-into-view'

const infoList = [
  {
    title: 'OWLGO’S PURPOSE',
    description: 'OwlGo started with this purpose: To provide a seamless event experience by empowering event organizers before, during, and after an event.'
  }, {
    title: 'WHY OWLGO?',
    description: 'We understand common problems event organizers face, like managing guest RSVP invitations. Managing these is a huge pain, especially when event organizers could have done higher value stuff.',
    description2: 'OwlGo solves these problems and empowers event organizers.'
  }, {
    title: 'MEET OWLGO',
    description: 'Get rid of the unnecessary hassle of having to deal with mistakes when inviting guests one at a time and managing guest list.',
    description2: 'And take delight in other value-added services that you find equally valuable.'
  }
]

const introButtonList = [
  {
    title: 'Ask your guest anything',
    to: '/#ask'
  },
  {
    title: 'Measure event performance',
    to: '/#data'
  },
  {
    title: 'Track event attendance real-time',
    to: '/#live'
  },
  {
    title: 'Brand your own event app',
    to: '/#brand'
  },
]

class Features extends Component {

  constructor(props) {
      super(props);
      this.state = {
          hoverLink: -1
      };
  }

  hover = (index) => {
      this.setState({hoverLink: index})
  }

  unhover = () => {
      this.setState({hoverLink: -1})
  }

  render () {

    return (
      <div>
        <div className='container-fluid pt-5 px-xl-5 px-3' id='seamless-rsvp-invitation' style={{position: 'relative', zIndex: '1'}}>
        	<div className='row mt-5'>
        		<div className='col-lg-6'>
              <Fade distance={'20px'} duration={600} bottom>
          			<div className='feature--intro-container' style={{margin: 'auto', maxWidth: '400px'}}>
                  <h6 className='features--h6'>Seamless RSVP</h6>
        	  			<h2 className='features--h2 mb-4'>Invite your guests</h2>
        	  			<p className='features--paragraph mb-4'>
        	  			  Send email invitations to guests with just a click. Manual checklists and messy spreadsheets are now a thing of the past.
                  </p>
                  <p className='features--paragraph mb-4'>
                    Know who is coming and who might need an additional nudge at a glance on the OwlGo app.
                  </p>
                  <p className='features--paragraph mb-3'>And do much, much more.</p>
                  {introButtonList.map((button, index) => {
                    return (
                      <div key={button.to} style={{maxWidth: '330px'}}>
                        <HashLink to={button.to} key={button.title} 
                         scroll={el =>  scrollIntoView(el,{ time:700, align:{top:0, left: 0}})}>
                          <button onMouseEnter={() => this.hover(index)} onMouseLeave={this.unhover} className='btn btn-primary d-flex align-items-center mb-2 feature--intro-button'>
                            <span className='pr-4' style={{fontSize: '10px', fontWeight:'500'}}>
                              {/*<span style={{border: this.state.hoverLink === index ? '1px solid white' : '1px solid #404041', borderRadius: '8px', letterSpacing: '0'}}>&nbsp;{index + 1}&nbsp;</span>*/}
                              <span className='feature--intro-button--title'>{button.title}</span>
                            </span>
                            <img alt='' src={this.state.hoverLink === index ? 'img/button-arrow.svg' : 'img/button-arrow-black.svg'} className='ml-auto feature--intro-button--arrow' />
                          </button>
                        </HashLink>
                      </div>
                      )
                  })}
          			</div>
              </Fade>
            </div>
            <div className='col-lg-6'>
              <img className='features--image-center' alt='header' src='img/owlgo-2.png' />
            </div>
        	</div>
        </div>
        <div className='feature--container--art1' style={{position: 'relative', zIndex: '2'}}>
          <div className='container-fluid pt-5 px-xl-5 px-3'>
            <span className="anchor" id="ask"/>
            <div className='row mt-5 feature--row-art1' id='customizable-rsvp-invitation-form'>
              <div className='col-lg-6 order-lg-2 d-flex align-items-center'>
                <img className='features--image-center' alt='header' src='img/owlgo-3.png' />
              </div>
              <div className='col-lg-6 order-lg-1 d-sm-flex align-items-center'>
                <Fade distance={'20px'} duration={600} bottom>
                  <div style={{margin: 'auto', maxWidth: '400px', color: '#fff'}}>
                    <h6 className='features--h6'>Tailor-Made RSVP Invitation Form</h6>
                    <h2 className='features--h2 mb-4'>Ask your guest anything</h2>
                    <p className='features--paragraph mb-lg-0 mb-5'>
                    Know your guests' needs before the event by gathering all relevant details with our customizable invitation form builder.</p>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
{/*          <div className='pt-5 container'>
            <div className='row' id='why-owlgo'>
              {
                infoList.map((info) => {
                  return (
                    <div className='col-md-4 mb-3'>
                      <div className='d-flex align-items-start flex-column' style={{background: '#f2f6f9', boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.2)', padding: '25px', height: '100%'}}>
                        <h6 className='mb-3' style={{letterSpacing: '0.1rem', fontWeight: '700'}}>{info.title}</h6>
                        <div className='mb-4' style={{fontSize: '0.9rem', color: '#472213'}}>{info.description}</div>
                        {info.description2 ? <div className='mb-4' style={{fontSize: '0.9rem', color: '#472213'}}>{info.description2}</div> : null}
                        <img src='img/user-star.png' className='mt-auto' style={{width: '40px'}} />
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>*/}
          <span className="anchor" id="data"/>
          <div className='container-fluid px-xl-5 px-3'>
            <div className='row' id='post-event-survey-data-analytics'>
              <div className='col-lg-6'>
                <img className='features--image-center' alt='header' src='img/owlgo-5.png' />
              </div>
              <div className='col-lg-6 d-sm-flex align-items-center'>
                <Fade distance={'20px'} duration={600} bottom>
                  <div style={{margin: 'auto', maxWidth: '400px', color: '#fff'}}>
                    <h6 className='features--h6'>Post-Event Survey and Data Analytics</h6>
                    <h2 className='features--h2 mb-4'>Measure your Event Performance</h2>
                    <p className='features--paragraph mb-5'>
                      Looking to improve your event? Gather feedback from your guests using OwlGo's post-event survey. 
                      Compare engagement data across events to further understand what it takes to better your future events.
                    </p>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
        {/*<span className="anchor" id="section2"/>*/}
        <div className='container-fluid py-5 px-xl-5 px-3'>
          <span className="anchor" id="live"/>
          <div className='row mt-5 pt-3' id='user-friendly-attendance-system'>
            <div className='col-lg-6 d-sm-flex align-items-start'>
              <Fade distance={'20px'} duration={600} bottom>
                <div style={{margin: 'auto', maxWidth: '400px'}}>
                  <h6 className='features--h6'>User-friendly Attendance System</h6>
                  <h2 className='features--h2 mb-4'>Real-time attendance tracking</h2>
                  <p className='features--paragraph'>
                  Check in your guests seamlessly. Access live event attendance statistics to refine program timings.</p>
                </div>
              </Fade>
            </div>
            <div className='col-lg-6 d-flex align-items-center'>
              <img className='features--image-center' alt='header' src='img/owlgo-4.png' />
            </div>
          </div>
        </div>
        <div className='feature--container--art2'>
          <div className='container-fluid py-5 px-xl-5 px-3' id='bespoke-branding'>
            <span className="anchor" id="brand"/>
            <div className='row mt-5' style={{paddingBottom: '50px'}}>
              <div className='col-lg-6 d-sm-flex align-items-center'>
                <Fade distance={'20px'} duration={600} bottom>
                  <div style={{margin: 'auto', maxWidth: '400px', color: '#fff'}}>
                    <h6 className='features--h6'>Bespoke Branding</h6>
                    <h2 className='features--h2 mb-4'>Brand your own Owlgo app</h2>
                    <p className='features--paragraph'>
                      Brand your own event app to send the ideal message across to your target audience. It's your event; do it your way!
                    </p>
                  </div>
                </Fade>
              </div>
              <div className='col-lg-6'>
                <img className='features--image-center' alt='header' src='img/owlgo-6.png' />
              </div>
            </div>
          </div>
        </div>
      </div>
      )
  }
}

const mapStateToProps = ( state, props ) => ({
  location:state.router.location
})

const mapDispatchToProps ={
    }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Features)


// WEBPACK FOOTER //
// ./src/components/landing/Feature.js